// src/ui/SystemTabs.js
import React, { useMemo, useState, useEffect } from 'react';
import { Tabs, TabList, Tab, TabPanel } from 'react-tabs';
import 'react-tabs/style/react-tabs.css';

export default function SystemTabs({ tabs = [], onTabChange, initialKey }) {
    const visibleTabs = useMemo(() => tabs.filter((t) => t && t.enabled !== false), [tabs]);

    const initialIndex = useMemo(() => {
        if (!initialKey) return 0;
        const idx = visibleTabs.findIndex((t) => t.key === initialKey);
        return idx >= 0 ? idx : 0;
    }, [initialKey, visibleTabs]);

    const [index, setIndex] = useState(initialIndex);

    // ✅ novo: se initialIndex mudar, atualiza o index
    useEffect(() => {
        setIndex(initialIndex);
    }, [initialIndex]);

    // ✅ garante index válido quando tabs mudarem
    useEffect(() => {
        if (index >= visibleTabs.length) setIndex(0);
    }, [visibleTabs.length, index]);

    // ✅ notifica mudança (inclui visibleTabs pra não usar array velho)
    useEffect(() => {
        const key = visibleTabs[index]?.key;
        if (key && typeof onTabChange === 'function') onTabChange(key);
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [index, visibleTabs]);

    if (!visibleTabs.length) return null;

    return (
        <Tabs selectedIndex={index} onSelect={setIndex}>
            <TabList>
                {visibleTabs.map((t) => (
                    <Tab key={t.key} title={t.title || ''}>
                        {t.label}
                    </Tab>
                ))}
            </TabList>

            {visibleTabs.map((t) => (
                <TabPanel key={t.key}>{t.panel}</TabPanel>
            ))}
        </Tabs>
    );
}
